<!-- ========== Left Sidebar Start ========== -->
<div class="left-side-menu">

  <div class="h-100" data-simplebar>

      <!--- Sidemenu -->
      <div id="sidebar-menu">

          <ul id="side-menu">
              <p>
                  popular

                  <a class="button-menu-mobile bmm-close">
                      <i class="mdi mdi-close"></i>
                  </a>
              </p>
              <!-- <li class="mo-home"></li> -->
              <li class="deposit dw" *ngIf="depoWithdrawCondition()">
                <a href="javascript:void(0)" (click)="closeSidebar();" routerLink="/deposit">
                    <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/deposit-icon.png">
                    <span> Deposit </span>
                </a>
            </li>
            <li class="withdraw dw" *ngIf="depoWithdrawCondition()">
                <a href="javascript:void(0)" (click)="closeSidebar();" routerLink="/withdraw">
                    <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/withdrawal-icon.png">
                    <span> Withdraw </span>
                </a>
            </li>
              <li class="deposit dw" *ngIf="demoLoginDepoWithdrawCondition()">
                <a href="javascript:void(0)" (click)="closeSidebar();" [href]="env.demoDWLink">
                    <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/deposit-icon.png">
                    <span> Deposit </span>
                </a>
            </li>
            <li class="withdraw dw" *ngIf="demoLoginDepoWithdrawCondition()">
                <a href="javascript:void(0)" (click)="closeSidebar();" [href]="env.demoDWLink">
                    <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/withdrawal-icon.png">
                    <span> Withdraw </span>
                </a>
            </li>
              <li class="">
                  <a href="javascript:void(0)" (click)="closeSidebar();" [routerLink]="isLogin() ? ['/dashboard'] : ['/home']">
                      <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/home.svg">
                      <span> home </span>
                  </a>
              </li>
              <li>
                  <a href="javascript:void(0)" (click)="closeSidebar();" routerLink="/inplay">
                      <img alt="" src="https://speedcdn.io/assets/radheexch-client/icons/in-play-icon.svg" class="img-fluid">
                      <span> in-play </span>
                  </a>
              </li>
              <li *ngIf="isLogin();">
                  <a href="javascript:void(0)" (click)="closeSidebar();" routerLink="/event/multi-market">
                      <img alt="" src="https://speedcdn.io/assets/radheexch-client/icons/market.svg" class="img-fluid">
                      <span> multi markets </span>
                  </a>
              </li>
              <li *ngFor="let mn of menu;let i=index;trackBy:trackByIndex">
                  
                  <!-- CASINO -->
                  <a (click)="closeSidebar();" href="javascript:void(0)" *ngIf="events.casino.includes(mn?.id)" [routerLink]="['/casino', mn?.id]" routerLinkActive="active">
                    <img alt="" src="https://speedcdn.io/assets/radheexch-client/icons/{{mn.id}}.svg" class="img-fluid">
                    <span> {{mn.name}} </span>
                  </a>

                  <!-- SPORTS AND RACES COMMON -->
                  <a href="#ui-basic-{{i}}" data-toggle="collapse" *ngIf="!events.casino.includes(mn?.id)">
                      <img alt="" src="https://speedcdn.io/assets/radheexch-client/icons/{{mn.id}}.png" class="img-fluid">
                      <span> {{mn.name}} </span>
                      <span class="menu-arrow"></span>
                  </a>

                  <!-- SPORTS LIST -->
                  <div class="collapse" id="ui-basic-{{i}}" *ngIf="(!events.casino.includes(mn?.id) && !events.races.includes(mn?.id))">
                      <ul class="nav-second-level">
                          <li *ngFor="let smn of mn.child;let j=index;trackBy:trackByIndex">
                              <a href="#ui-basic-inner-{{i}}{{j}}" data-toggle="collapse" class="collapsed" aria-expanded="false">
                                  <span class="menu-arrow"></span> {{smn.name}}
                              </a>
                              <div class="collapse" id="ui-basic-inner-{{i}}{{j}}" style="">
                                  <ul class="nav-second-level">
                                      <li *ngFor="let item of smn.data;let k=index;trackBy:trackByIndex">
                                          <a class="white-space-normal" (click)="closeSidebar();" routerLinkActive="active" [routerLink]="['/event/detail', item?.event_id]">
                                              {{item.name}}
                                          </a>
                                      </li>
                                  </ul>
                              </div>
                          </li>
                      </ul>
                  </div>

                  <!-- RACE LIST -->
                  <div class="collapse" id="ui-basic-{{i}}" *ngIf="events.races.includes(mn?.id)">
                    <ul class="nav-second-level">
                        <li *ngFor="let item of mn.data;let j=index;trackBy:trackByIndex">
                            <a (click)="closeSidebar();" class="white-space-normal" routerLinkActive="active" href="javascript:void(0)"
                            [routerLink]="['/event/detail',item.event_id, item?.market_id]">
                                {{item.event_name}} ({{item.market_start_time_format | date: 'hh:mm a'}})
                            </a>
                        </li>
                    </ul>
                </div>

              </li>

              <li>
                <a href="javascript:void(0)" (click)="redirectCasinoWithTabSelection(99995, 4)">
                  <img alt="" src="https://speedcdn.io/assets/radheexch-client/icons/icon-ezugi.png" class="img-fluid">
                  ezugi
                </a>
              </li>
              <li>
                  <a href="javascript:void(0)" (click)="redirectCasinoWithTabSelection(99995, 1)">
                    <img alt="" src="https://speedcdn.io/assets/radheexch-client/icons/icon-evolution.png" class="img-fluid">
                    evolution
                  </a>
              </li>
              <li>
                  <a href="javascript:void(0)" (click)="redirectCasinoWithTabSelection(99995, 5)">
                    <img alt="" src="https://speedcdn.io/assets/radheexch-client/icons/icon-bombay.png" class="img-fluid">
                    bombay gaming
                  </a>
              </li>
              <li>
                  <a href="javascript:void(0)" (click)="redirectCasinoWithTabSelection(99995, 24)">
                    <img alt="" src="https://speedcdn.io/assets/radheexch-client/icons/icon-betgames.png" class="img-fluid">
                    betgames
                  </a>
              </li>
              
              <!-- <li>
                  <a href="#">
                      <img alt="" src="assets/img/football-ball.png" class="img-fluid">
                      <span>soccer</span>
                  </a>
              </li>
              <li>
                  <a href="#tennis" data-toggle="collapse">
                      <img alt="" src="assets/img/tennis-ball.png" class="img-fluid">
                      <span> tennis </span>
                      <span class="menu-arrow"></span>
                  </a>
                  <div class="collapse" id="tennis">
                      <ul class="nav-second-level">
                          <li>
                              <a href="#tennisthirdLevel" data-toggle="collapse" class="collapsed" aria-expanded="false">
                                  <span class="menu-arrow"></span> indian premium league
                              </a>
                              <div class="collapse" id="tennisthirdLevel" style="">
                                  <ul class="nav-second-level">
                                      <li>
                                          <a href="javascript: void(0);"><i class="mdi mdi-plus"></i>Kent T10 (Virtual) V Somerset T10 (Virtual)</a>
                                      </li>
                                      <li>
                                          <a href="javascript: void(0);"><i class="mdi mdi-plus"></i>Kent T10 (Virtual) V Somerset T10 (Virtual)</a>
                                      </li>
                                  </ul>
                              </div>
                          </li>
                      </ul>
                  </div>
              </li>

              <li>
                  <a href="#">
                      <img alt="" src="assets/img/horse-icon.png" class="img-fluid">
                      <span>horse</span>
                  </a>
              </li>
              <li>
                  <a href="#">
                      <img alt="" src="assets/img/grayhound-icon.png" class="img-fluid">
                      <span>greyhound</span>
                  </a>
              </li>
              <li>
                  <a href="#">
                      <img alt="" src="assets/img/trophy.svg" class="img-fluid">
                      <span>ipl winner</span>
                  </a>
              </li>
              <li>
                  <a href="indianpoker.php">
                      <img alt="" src="assets/img/indian-poker-icon.svg" class="img-fluid">
                      <span>indian poker</span>
                  </a>
              </li>
              <li>
                  <a href="">
                      <img alt="" src="assets/img/casino-icon.svg" class="img-fluid">
                      <span>casino</span>
                  </a>
              </li>
              <li>
                  <a href="#">
                      <img alt="" src="assets/img/virtualgameicon.png" class="img-fluid">
                      <span>virtual sports</span>
                  </a>
              </li>
              <li>
                  <a href="#">
                      <img alt="" src="assets/img/binary-icon.svg" class="img-fluid">
                      <span>binary</span>
                  </a>
              </li> -->
          </ul>

      </div>
      <!-- End Sidebar -->

      <div class="clearfix"></div>

  </div>
  <!-- Sidebar -left -->

</div>
<!-- Left Sidebar End -->
